<script>
    import ShareButton from "./ShareButton.svelte";
    import BackButton from "../../common/buttons/BackButton.svelte";
    import SearchButton from "./SearchButton.svelte";
    import { createEventDispatcher } from "svelte";
    import CloseButton from "./CloseButton.svelte";
    import CodeButton from "./CodeButton.svelte";
    import GeneralHeaderBar from "../../common/header/GeneralHeaderBar.svelte";
    import { onMount } from "svelte";
    import Clipboard from "clipboard";

    export let title;
    export let hideBackButton = false;
    export let hideSeperator = false;
    export let showTitleAlways = false;
    export let backgroundColor = "var(--white-100)";
    export let onSite = false;
    export let hideLogo = false;

    export let search = false;
    export let share = false;
    export let close = false;
    export let info = false;
    export let code = false;
    export let flexHeader;
    let clip;
    let codeB;
    let button = "";
    let linkCopied;

    let time = new Date();

    $: seconds = time.getSeconds();

    const dispatch = createEventDispatcher();

    function actionClicked() {
        dispatch("actionClicked");
    }

    function copyLink() {
        linkCopied = true;
    }

    function disappearCopyLink() {
        linkCopied = false;
    }

    let bottomMargin = "72px";

    onMount(() => {
        codeB = window.location.href;
        if (button == "") return;
        clip = new Clipboard(button, { text: (trigger) => codeB });
        const interval = setInterval(disappearCopyLink, 2000);
    });
</script>

<GeneralHeaderBar
    {title}
    {backgroundColor}
    {hideSeperator}
    {showTitleAlways}
    {linkCopied}
    {flexHeader}
    {onSite}
    {hideLogo}
>
    <div slot="pre-title">
        {#if !hideBackButton && !close}
            <BackButton />
        {:else}
            <div style="width: 32px; height: 32px;" />
        {/if}
    </div>

    <div slot="post-title">
        {#if search}
            <SearchButton on:click={actionClicked} />
        {:else if share}
            <div bind:this={button}>
                <ShareButton on:click={copyLink} />
            </div>
        {:else if close}
            <CloseButton on:click={actionClicked} />
        {:else if code}
            <CodeButton on:click={actionClicked} />
        {:else}
            <div style="width: 32px; height: 32px;" />
        {/if}
    </div>
</GeneralHeaderBar>
